// File: src/components/management/UserAvailability/SpecialAvailabilities.jsx

import React from "react";

export default function SpecialAvailabilities({
  allUsers,
  selectedSAUser,
  setSelectedSAUser,
  saDate,
  setSADate,
  allSpecials,
  handleAddSpecial,
  handleDeleteSpecial,
  loadingSpecial
}) {
  return (
    <section className="ua-special-section">
      <h2>Special Availabilities</h2>
      {loadingSpecial && <div className="ua-loading">Loading…</div>}

      <div className="ua-unavail-form">
        <div className="ua-form-group">
          <label htmlFor="sa-user-select">User:</label>
          <select
            id="sa-user-select"
            value={selectedSAUser}
            onChange={(e) => setSelectedSAUser(e.target.value)}
          >
            <option value="">-- Choose user --</option>
            {allUsers.map((u) => (
              <option key={u.USER_ID} value={u.USER_ID}>
                {u.USER_NAME} {u.USER_SURNAME} ({u.COMPANY_NAME})
              </option>
            ))}
          </select>
        </div>
        <div className="ua-form-group">
          <label htmlFor="sa-date-input">Date:</label>
          <input
            type="date"
            id="sa-date-input"
            value={saDate}
            onChange={(e) => setSADate(e.target.value)}
          />
        </div>
        <div className="ua-form-group">
          <button
            className="ua-btn ua-btn-add-unavail"
            onClick={handleAddSpecial}
            disabled={loadingSpecial}
          >
            {loadingSpecial ? "Adding…" : "Add Special Availability"}
          </button>
        </div>
      </div>

      <div className="ua-unavail-table-wrapper">
        <table className="ua-unavail-table">
          <thead>
            <tr>
              <th>User</th>
              <th>Date</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {allSpecials.map((rec) => (
              <tr key={`${rec.user_id}__${rec.special_date}`}>
                <td data-label="User">
                  {rec.USER_NAME} {rec.USER_SURNAME} ({rec.COMPANY_NAME})
                </td>
                <td data-label="Date">{rec.special_date}</td>
                <td data-label="Delete">
                  <button
                    className="ua-btn ua-btn-delete-unavail"
                    onClick={() => handleDeleteSpecial(rec.user_id, rec.special_date)}
                    disabled={loadingSpecial}
                  >
                    ✖
                  </button>
                </td>
              </tr>
            ))}
            {allSpecials.length === 0 && (
              <tr>
                <td colSpan="3" className="ua-no-data">
                  No special availabilities added.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}
